import Head from "next/head"
import { renderMetaTags } from "react-datocms"
import { useMemo } from "react"
import { LOCALES } from "@repo/utils/constants"
import { useRouter } from "next/router"
import { getPropSafely, slugify } from "@repo/utils"

const IS_PROD = process.env.IS_PROD === "true"
const SITE_URL = process.env.SITE_URL

function formatCanonicalUrl(url, locale) {
	const localePrefix = locale === LOCALES.EN ? "" : `${locale}/`
	const cleanPath = `${url || ""}`.split(/[?#]/)[0]
	let slug = cleanPath.replace(/^\/+/, "")
	if (slug === "home") {
		slug = ""
	}
	return slugify(`${SITE_URL}${localePrefix}${slug}`)
}

export default function Seo({ data = [] }) {
	const metaTags = getPropSafely(data, "_seoMetaTags", [])
	const router = useRouter()
	const canonicalHref = useMemo(() => formatCanonicalUrl(router.asPath, router.locale), [router.asPath, router.locale])

	const hasDisableRobotsTag = metaTags.some(({ attributes }) => attributes?.name === "robots" && attributes?.content === "noindex")

	return (
		<Head>
			{renderMetaTags(metaTags)}
			<link rel="canonical" href={canonicalHref} hrefLang={router.locale} />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<link rel="icon" href="/favicon.svg" />
			<meta name="robots" content={!IS_PROD || hasDisableRobotsTag ? "no index" : "index, follow"} />
		</Head>
	)
}
